<template>
  <div class="rooms-page">
    <Hero :title="hero?.title" :description="hero?.description">
      <template #image>
        <ElementsImage v-if="hero?.image" v-bind="hero.image" />
      </template>
    </Hero>
    <ElementsContainer>
      <RoomsFeatures />
      <div class="flex flex-wrap -mx-4 gap-y-10 md:gap-y-15">
        <div v-for="room in rooms" :key="room.id" class="w-full lg:w-1/2 px-4">
          <RoomsCard v-bind="room" />
        </div>
      </div>
      <Comments />
    </ElementsContainer>
  </div>
</template>

<script setup lang="ts">
  import fetchApi from "~/utils/fetchApi"

  const { data: roomsData } = await useAsyncData("rooms", () =>
    fetchApi<any[]>("rooms", {
      wrappedByKey: "data",
      populate: "*",
      query: {
        sort: ["msquare:asc"]
      }
    })
  )

  const { data: pageData } = await useAsyncData("room-page", () =>
    fetchApi<any>("room-page", {
      wrappedByKey: "data",
      populate: {
        hero: { populate: "*" }
      }
    })
  )

  const rooms = computed(() => roomsData.value || [])
  const hero = computed(() => pageData.value?.hero || {})

  const { t } = useI18n()

  useSeoMeta({
    title: () => hero.value?.title || t("menu.rooms"),
    description: () => hero.value?.description || ""
  })
</script>

<style lang="scss" scoped>
  .rooms-page {
    .rooms-list {
      @apply grid grid-cols-2;
    }
  }
</style>
